<template>
  <loader v-bind="{ loading }">

  <page-navigation :title="`Audits (${audits.total})`">
    <template #subtitle>
      <span>Audits assess your applications compliance level against industry standards.</span>
    </template>
    <template #right>
      <search-bar
        v-model="filters.search"
        @run-search="searchForItems"
        @clear-search="clearSearch"
      />
    </template>
  </page-navigation> 
    <index-row
      :title="`#${audit.number} for ${audit.app.name}, ${audit.environment.name}`"
      has-avatar
      :avatar="{ path: audit.app.logo_url, name: audit.app.name }"
      :route="{
        name: 'audit-manager',
        params: {
          audit: audit.id,
          app: audit.app_id,
        }
      }"
      v-for="audit in audits.data" :key="audit.id">
      <span class="help">{{ audit.created_at | asCalendar }}</span>

      <template #right>
        <flex column class="mr-5 has-text-centered">
          <p>
            {{ audit.compliance_percentage }}%
          </p>
          Compliant
        </flex>
        <flex column class="mr-5 has-text-centered">
          <p>
            {{ findingsCount(audit) }}
          </p>
          Findings
        </flex>
      </template>
    </index-row>

    <pager v-if="audits.next_page_url || audits.prev_page_url" context="audit" :pageable="audits" @nav="goTo"/>
        
    <no-items-to-show v-if="!audits.data.length && !audits.total" text="No Audits Found">
      <router-link
        :to="{ name: 'create-audit' }"
        class="is-rounded button">
        <icon icon="plus"/>
        <span>Start an Audit</span>
      </router-link>
    </no-items-to-show>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Apps',

  data: () => ({
    audits: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', `Audits`)
  },

  created() {
    if (this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadItems()
  },

  methods: {
    loadItems() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({ data }) => {
        this.audits = data
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    searchForItems() {
      if (!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'audits',
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'audits',
        query: {}
      })
    },
    findingsCount(audit) {
      return audit.findings.length
    }
  },

  watch: {
    '$route': 'loadItems'
  }
}
</script>
